import * as _ from 'lodash';
import { FormEvent } from 'react';
import { IRecipientProfilePostTransplantData } from '@nkr/models/index';
import { FormControl } from 'react-bootstrap';
import { CreatinineTableWrapper } from '../styles';
import MaskedInput from 'react-maskedinput';
import { IValidation } from './validation';

interface IProps {
    data: IRecipientProfilePostTransplantData,
    validation: IValidation,
    onChange: (data: IRecipientProfilePostTransplantData) => void,
}

const Creatinine = (props: IProps) => {
    const handleDataChange = (e: FormEvent<FormControl & HTMLInputElement & HTMLSelectElement>) => {
        let data = _.cloneDeep(props.data);

        let { name, value } = e.currentTarget;

        data[name] = value;

        props.onChange(data);
    };

    let rowList = [
        {
            label: 'Admit',
            col1: { id: 'admitCreatinine', value: props.data.admitCreatinine },
            col2: { id: 'admitCreatinineDate', value: props.data.admitCreatinineDate }
        },
        {
            label: 'One Week',
            col1: { id: 'creatinineWeek', value: props.data.creatinineWeek },
            col2: { id: 'creatinineWeekDate', value: props.data.creatinineWeekDate }
        },
        {
            label: 'One Month',
            col1: { id: 'creatinineMonth', value: props.data.creatinineMonth },
            col2: { id: 'creatinineMonthDate', value: props.data.creatinineMonthDate }
        },
        {
            label: 'Six Month',
            col1: { id: 'creatinine6Month', value: props.data.creatinine6Month },
            col2: { id: 'creatinine6MonthDate', value: props.data.creatinine6MonthDate }
        },
        {
            label: 'One Year',
            col1: { id: 'creatinineYear', value: props.data.creatinineYear },
            col2: { id: 'creatinineYearDate', value: props.data.creatinineYearDate }
        },
        {
            label: 'Two Year',
            col1: { id: 'creatinineYear2', value: props.data.creatinineYear2 },
            col2: { id: 'creatinineYear2Date', value: props.data.creatinineYear2Date }
        },
        {
            label: 'Three Year',
            col1: { id: 'creatinineYear3', value: props.data.creatinineYear3 },
            col2: { id: 'creatinineYear3Date', value: props.data.creatinineYear3Date }
        },
        {
            label: 'Four Year',
            col1: { id: 'creatinineYear4', value: props.data.creatinineYear4 },
            col2: { id: 'creatinineYear4Date', value: props.data.creatinineYear4Date }
        },
        {
            label: 'Five Year',
            col1: { id: 'creatinineYear5', value: props.data.creatinineYear5 },
            col2: { id: 'creatinineYear5Date', value: props.data.creatinineYear5Date }
        },
        {
            label: 'Six Year',
            col1: { id: 'creatinineYear6', value: props.data.creatinineYear6 },
            col2: { id: 'creatinineYear6Date', value: props.data.creatinineYear6Date }
        },
        {
            label: 'Seven Year',
            col1: { id: 'creatinineYear7', value: props.data.creatinineYear7 },
            col2: { id: 'creatinineYear7Date', value: props.data.creatinineYear7Date }
        },
        {
            label: 'Eight Year',
            col1: { id: 'creatinineYear8', value: props.data.creatinineYear8 },
            col2: { id: 'creatinineYear8Date', value: props.data.creatinineYear8Date }
        },
        {
            label: 'Nine Year',
            col1: { id: 'creatinineYear9', value: props.data.creatinineYear9 },
            col2: { id: 'creatinineYear9Date', value: props.data.creatinineYear9Date }
        },
        {
            label: 'Ten Year',
            col1: { id: 'creatinineYear10', value: props.data.creatinineYear10 },
            col2: { id: 'creatinineYear10Date', value: props.data.creatinineYear10Date }
        },
    ];

    return (
        <CreatinineTableWrapper condensed bordered>
            <thead>
                <tr>
                    <th>&nbsp;</th>
                    <th>Creatinine</th>
                    <th>Date</th>
                </tr>
            </thead>
            <tbody>
                {rowList.map((item, index) => {
                    let valid = props.validation.creatinine[index];

                    return (
                        <tr key={'creat-' + index}>
                            <td style={{ textAlign: 'right' }}><label>{item.label}:</label></td>
                            <td className={!valid.value ? 'has-error' : null}>
                                <FormControl
                                    name={item.col1.id}
                                    bsSize='sm'
                                    value={item.col1.value}
                                    onChange={handleDataChange} />
                            </td>
                            <td className={!valid.date ? 'has-error' : null}>
                                <MaskedInput
                                    name={item.col2.id}
                                    className='form-control input-sm'
                                    mask='11/11/1111'
                                    placeholder='MM/DD/YYYY'
                                    value={item.col2.value}
                                    onChange={handleDataChange}
                                />
                            </td>
                        </tr>
                    );
                })}
            </tbody>
        </CreatinineTableWrapper>
    );
}

export default Creatinine;